<template>
  <div class="container-plans">
    <ul class="box-group ls-md-margin-bottom" v-if="subscribePlans.length">
      <box-info class="col-md-4" :class="{ 'suggested-plan': plan.suggested }" v-for="plan in plans" v-bind:key="plan">
        <div slot="suggested" v-if="plan.suggested" class="ribbon ribbon-top-right"><span>{{ $t('subscribe.attributes.suggested') }}</span></div>
        <h6 class="ls-text-xl" slot="title">{{ plan.name }}</h6>
        <h3 slot="value">R$ <span>{{ money.parseViewValue(plan.price) }}</span></h3>
        <p v-if="plan.periodicity === 1" slot="periodicity">Cobrado mensalmente</p>
        <p v-else slot="periodicity">Cobrado uma vez a cada {{ plan.periodicity }} meses</p>
        <p slot="description" class="plan-description">{{ plan.description }}</p>
        <footer slot="footer" class="ls-box-footer">
          <button @click="step(plan)" class="ls-btn ls-btn-lg ls-full-width" :class="[plan.suggested ? 'ls-btn-primary' : 'btn-custom']">{{ $t('subscribe.buttons.hire') }}</button>
        </footer>
      </box-info>
      <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw ls-full-width ls-display-block" v-if="loadMore && allPlans > 0"></i>
      <p v-if="allPlans === 0" class="ls-full-width ls-txt-center">{{ $t('subscribe.messages.showing_total') }}  {{ subscribePlans.length }} {{ $t('subscribe.attributes.plans') }}</p>
    </ul>
    <p class="ls-txt-center-all" v-else>{{ $t('subscribe.attributes.plan_not_found') }}</p>
    <div v-if="autoLoad">
      <button type="button" class="ls-btn ls-btn-lg ls-btn-primary ls-md-margin-bottom" @click="loadAll">{{ $t('subscribe.buttons.load_more_planes') }}</button>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import BoxInfo from './components/BoxInfo.vue'
  import money from 'src/utils/money'
  import * as types from './vuex/mutations-types'
  import * as location from 'src/utils/location'

  export default {
    name: 'plan',
    components: { BoxInfo },
    data () {
      return {
        active: false,
        money: money,
        showPlans: 4,
        loadMore: false
      }
    },
    methods: {
      ...mapActions(['loadPlansByUsername']),
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      step (value) {
        this.$store.commit(types.setChosenPlan, value)
        this.$loader.show()
        var self = this
        this.$loader.show(setTimeout(function () {
          self.$loader.hide()
          self.$emit('step')
        }, 500))
      },
      afterLoadPlans () {
        this.$loader.hide()
      },
      loadAll () {
        this.loadMore = true
        setTimeout(() => {
          this.showPlans += this.showPlans
          this.loadMore = false
        }, 500)
        this.autoLoad = true
        this.endPage()
      },
      endPage () {
        let self = this
        if (self.autoLoad) {
          window.onscroll = function (ev) {
            if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - 150) {
              self.beforeLoader()
            }
          }
        }
      },
      beforeLoader () {
        if (this.loadMore) return
        if (this.showPlans < this.subscribePlans.length) this.loadMore = true
        setTimeout(() => {
          this.showPlans += this.showPlans
          this.loadMore = false
        }, 500)
      }
    },
    computed: {
      ...mapGetters(['subscribePlans', 'chosenPlan', 'basicSeller']),
      plans () {
        return this.subscribePlans.length > 0 ? this.subscribePlans.slice(0, this.showPlans) : {}
      },
      autoLoad () {
        return this.subscribePlans.length > this.showPlans
      },
      allPlans () {
        return this.subscribePlans.length
      }
    },
    mounted () {
      this.loadPlansByUsername(this.getUsernameFromUrl()).then(this.afterLoadPlans)
      this.endPage()
    }
  }
</script>
<style lang="scss" scoped>
  .ls-btn {
    margin: 0 auto;
    display: block;
  }
  .btn-custom {
    background: #ff7e7e;
    color: white;
    border: none;
  }
  .ls-box {
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 30px;
    width: 270px;
  }
  .container-plans {
    margin-right:auto;
    margin-left:auto;
    padding-left:15px;
    padding-right:15px
  }
  @media screen and (min-width: 768px) {
    .container-plans {
      width: 750px
    }
  }
  @media screen and (min-width: 992px){
    .container-plans {
      width:970px
    }
  }
  @media screen and (min-width: 1200px){
    .container-plans {
      width:1300px
    }
  }
</style>



// WEBPACK FOOTER //
// Plan.vue?237f97d3